import PropTypes from 'prop-types'
import { Table } from 'baseui/table-semantic'
import { SIZE } from 'baseui/input'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { KIND, SIZE as BUTTON_SIZE } from 'baseui/button'

const AdditionalProductsList = ({ items, onSort, sortKey, sortDirection, onDelete, onRestore, loadingId }) => {
  const columnsMeta = [
    { key: 'id', label: 'ID' },
    { key: 'type', label: 'Type' },
    { key: 'name', label: 'Name' },
    { key: 'potential_name', label: 'Potential name' },
    { key: 'country', label: 'Country' },
    { key: 'business_type', label: 'Business type' },
    { key: 'zoho_id', label: 'Zoho ID' },
    { key: 'attributes', label: 'attributes' },
    { key: 'group', label: 'group' },
    { key: 'order', label: 'order' },
    { key: 'is_active', label: 'Active' },
    { key: 'deleted_at', label: 'Deleted at' },
    { key: 'action', label: 'Action' },
  ]

  const COLUMNS = columnsMeta.map(col => {
    if (col.key === 'action') return col.label
    const isSorted = sortKey === col.key
    const arrow = isSorted ? (sortDirection === 'ASC' ? ' \u25B2' : ' \u25BC') : ''
    return (
      <button
        key={col.key}
        onClick={() => onSort(col.key)}
        style={{
          cursor: 'pointer',
          background: 'none',
          border: 'none',
          fontWeight: isSorted ? 600 : 400,
          display: 'flex',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <span>
          {col.label}
          {arrow}
        </span>
      </button>
    )
  })

  const renderAttributes = value => {
    if (value == null) return '-'
    if (typeof value === 'string') return value
    try {
      return JSON.stringify(value)
    } catch {
      return '-'
    }
  }

  const data = items.map(p => [
    p.id,
    p.type,
    p.name,
    p.potential_name,
    p.country || '-',
    p.business_type || '-',
    p.zoho_id || '-',
    renderAttributes(p.attributes),
    p.group || '-',
    p.order || '-',
    p.is_active ? 'Yes' : 'No',
    p.deleted_at ? new Date(p.deleted_at).toLocaleString() : '-',
    p.deleted_at ? (
      <SDButton
        key={`restore-${p.id}`}
        size={BUTTON_SIZE.mini}
        kind={KIND.secondary}
        onClick={() => onRestore(p)}
        isLoading={loadingId === p.id}
      >
        Restore
      </SDButton>
    ) : (
      <SDButton
        key={`delete-${p.id}`}
        size={BUTTON_SIZE.mini}
        kind={KIND.secondary}
        onClick={() => onDelete(p)}
        isLoading={loadingId === p.id}
      >
        Delete
      </SDButton>
    ),
  ])

  const overrides = {
    TableHeadCell: {
      style: {
        backgroundColor: '#E8EFF7',
        color: '#171A1C',
      },
    },
    TableBodyRow: {
      style: ({ $theme, $rowIndex }) => {
        const deleted = items[$rowIndex]?.deleted_at
        const zebra = $rowIndex % 2 ? $theme.colors.backgroundPrimary : $theme.colors.backgroundSecondary
        const deletedColor = $theme.colors.negative50 || '#ffeaea'
        return {
          backgroundColor: deleted ? deletedColor : zebra,
          ':hover': {
            backgroundColor: deleted ? $theme.colors.negative100 || '#ffdede' : $theme.colors.backgroundTertiary,
          },
          transition: 'background-color .15s ease',
        }
      },
    },
  }

  return (
    <Table overrides={overrides} size={SIZE.compact} columns={COLUMNS} data={data} emptyMessage={<h1>No results</h1>} />
  )
}

AdditionalProductsList.propTypes = {
  items: PropTypes.array.isRequired,
  onSort: PropTypes.func.isRequired,
  sortKey: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
  loadingId: PropTypes.number,
}

export default AdditionalProductsList
